
 <span *ngIf="load.pos == pos && load.active" class="spinner-glow spinner-glow-primary mr-5 loader"></span>